import { render } from "./BalCloseIcon.vue?vue&type=template&id=4b9e3786"
const script = {}

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__